import { Alert } from '@mui/material';

export function NotLinked() {
  return (
    <Alert severity="info">
      This login isn&apos;t linked to a resident record yet. Ask your property manager for an
      invitation.
    </Alert>
  );
}
